<template>
  <tr
    class="font-sans text-xs border-b border-brand-gray-300 w-full bg-white relative left-12 right-12"
  >
    <td class="py-4" colspan="2">
      <div class="flex items-center gap-3">
        <span class="text-black font-bold">{{ $t('applicantName') }}:</span>
        <span class="text-gray-500" v-html="checkApplicantName(requestDraft)"> </span>
      </div>

      <div class="flex items-center gap-3">
        <span class="text-black font-bold">{{ $t('mobileNumber') }}:</span>
        <span class="text-gray-500">
          {{ requestDraft.request.localMobile }}
        </span>
      </div>
    </td>
    <td class="py-4" colspan="2">
      <div class="flex items-center gap-3">
        <span class="text-black font-bold">{{ $t('email') }}:</span>
        <span class="text-gray-500">{{ requestDraft.request.emailAddress }}</span>
      </div>

      <div class="flex items-center gap-3">
        <span class="text-black font-bold">{{ $t('userName') }}:</span>
        <span class="text-gray-500">{{ requestDraft.userName }}</span>
      </div>
    </td>
  </tr>
</template>

<script setup>
const props = defineProps({
  requestDraft: {
    type: Object,
    default: () => {}
  },
  genderText: {
    type: String,
    default: () => ''
  }
})
const checkApplicantName = (draft) => {
  return draft.arabicApplicantName + ' | ' + draft.englishApplicantName
}
</script>

<style></style>
